import * as Yup from "yup";
import moment from "moment";
import gene20FormModel from "./gene20FormModel";
const {
  formField: {
    firstName,
    lastName,
    email,
    password,
    profilePic,
    dateOfBirth,
    gender,
    phoneContact1,
    location,
    whatsappContact,
  },
} = gene20FormModel;

export default [
  Yup.object().shape({
    [firstName.name]: Yup.string().required(`${firstName.requiredErrorMsg}`),
    [lastName.name]: Yup.string().required(`${lastName.requiredErrorMsg}`),
    [email.name]: Yup.string()
      .email("invalid email , enter valid email")
      .required(`${email.requiredErrorMsg}`),
    [password.name]: Yup.string()
      .min(8, "Password should be of minimum 8 characters length")
      .required(`${password.requiredErrorMsg}`),
  }),
  Yup.object().shape({
    [location.name]: Yup.string().required(`${location.requiredErrorMsg}`),
    [whatsappContact.name]: Yup.string()
      .nullable(),
    [gender.name]: Yup.string().required(`${gender.requiredErrorMsg}`),
    [profilePic.name]: Yup.mixed().nullable().notRequired(),
    [dateOfBirth.name]: Yup.string()
      .required(`${dateOfBirth.requiredErrorMsg}`)
      .test("birthday", dateOfBirth.invalidErrorMsg, (val) => {
        if (val) {
          const startDate = new Date(1960, 12, 31);
          const endDate = new Date(2004, 12, 31);
          if (moment(val, moment.ISO_8601).isValid()) {
            return moment(val).isBetween(startDate, endDate);
          }
          return false;
        }
        return false;
      }),
    [phoneContact1.name]: Yup.string()
      .required(`${phoneContact1.requiredErrorMsg}`)
      .test(
        "len",
        `${phoneContact1.invalidErrorMsg}`,
        (val) => val && val.length === 10
      ),
  }),
];
